<template>
  <div class="modal fade" id="viewCommunication" role="dialog">
    <div class="modal-dialog modal-dialog-35">
      <!-- Modal content-->
      <div class="modal-content modal-communication">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="type">
              <span v-if="viewValue.userNoticeType === 2" class="nunito background-red">Importante</span>
              <span v-if="viewValue.userNoticeType === 1" class="nunito background-bue">Normal</span>
            </div>
            <p class="nunito">{{viewValue.createdAt | formatDateHours}}</p>
          </div>

        <div class="modal-body">
          <h4 class="certa">{{viewValue.title}}</h4>
          <p class="nunito">{{viewValue.message}}</p>
        </div>

        <div class="modal-footer offset-top-20">
          <button v-on:click="closeModal()" class="nunito btn-yellow-save">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "view-communication",
    props:['viewValue'],
    methods: {
      closeModal() {
        $('#viewCommunication').modal('toggle');
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/vue/views/modals/viewCommunication.vue